import { t } from 'i18next';
import { OptionI } from '../../types/interface';
import { capitalizeFirstLetter } from './helpers';
import {
  ACTIVE,
  APPROVED,
  ARCHIVE,
  CARINTHIA,
  CUSTOM_REFUNDABLE,
  EARLY_RETIREMENT,
  EDUCATION,
  HEALTH,
  HEALTH_ENUM,
  INTERNAL_EMPLOYEE,
  LEASING_AND_PAYROLLING,
  NOT_REFUNDABLE,
  PENDING,
  REFUNDABLE,
  REJECTED,
  RefundPolicy,
  SALZBURG,
  SAP_AGREE,
  SAP_DISAGREE,
  SCHOOL_ACTIVITY_OF_CHILD_ENUM,
  STYRIA,
  TYROL,
  UPPER_AUSTRIA,
  VORARLBERG,
  VPA_OST_1,
  VPA_OST_2,
  VPA_OST_3,
  WITHOUT_INCOME,
  WITH_INCOME
} from './enums/misc';
import { TabItems } from 'base/StandardTab/tabInterface';
import { faHistory, faUser } from '@fortawesome/free-solid-svg-icons';

export const userTypeOption = [
  {
    label: t('register_applicant.radioButtons1.label_1'),
    value: 'active_employee'
  },
  {
    label: t('user.option.label_2'),
    value: 'early_retirement'
  }
];

export const user_type: OptionI[] = [
  {
    label: capitalizeFirstLetter(t('register_applicant.radioButtons1.label_2')),
    value: INTERNAL_EMPLOYEE
  },
  {
    label: capitalizeFirstLetter(t('user.option.label_2')),
    value: EARLY_RETIREMENT
  },
  {
    label: capitalizeFirstLetter(t('register_applicant.radioButtons2.label_1')),
    value: LEASING_AND_PAYROLLING
  }
];

export const archiveSearchOptions = [
  {
    value: ARCHIVE,
    label: capitalizeFirstLetter(t('common_table.text_5'))
  },
  {
    value: ACTIVE,
    label: capitalizeFirstLetter(t('common_table.text_4'))
  }
];

export const userTypeOptions: OptionI[] = [
  {
    label: capitalizeFirstLetter(t('user.user_type.label_1')),
    value: 'admin'
  },
  {
    label: capitalizeFirstLetter(t('header.text.text_2')),
    value: 'user'
  }
];

export const federal_state: OptionI[] = [
  {
    label: t('register_applicant.dropdown.option_1'),
    value: VPA_OST_3.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_2'),
    value: VPA_OST_2.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_3'),
    value: VPA_OST_1.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_4'),
    value: UPPER_AUSTRIA.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_5'),
    value: SALZBURG.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_6'),
    value: TYROL.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_7'),
    value: STYRIA.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_8'),
    value: CARINTHIA.toLowerCase()
  },
  {
    label: t('register_applicant.dropdown.option_9'),
    value: VORARLBERG.toLowerCase()
  }
];

export const sap_agree_radio: OptionI[] = [
  {
    label: t('register_applicant.radioButtons4.label_1'),
    value: SAP_AGREE
  },
  {
    label: t('register_applicant.radioButtons5.label_1'),
    value: SAP_DISAGREE
  }
];

export const basicDataOptions: OptionI[] = [
  {
    label: t('header.text.text_10'),
    value: WITH_INCOME
  },
  {
    label: t('header.text.text_11'),
    value: WITHOUT_INCOME
  }
];

export const statusOptions: OptionI[] = [
  {
    label: t('applications.status.text_1'),
    value: APPROVED
  },
  {
    label: t('applications.status.text_2'),
    value: REJECTED
  },
  {
    label: t('applications.status.text_3'),
    value: PENDING
  }
];

export const debounceTime: number = 1000;

export const dataPerPageSelectOptions: number[] = [10, 20, 50, 100];

export const ApplicationTypes: OptionI[] = [
  {
    label: t('applications.application_type.text_1'),
    value: HEALTH_ENUM
  },
  {
    label: t('applications.application_type.text_2'),
    value: SCHOOL_ACTIVITY_OF_CHILD_ENUM
  }
];

export const refundOptions = [
  { label: t('product_form.placeholder.text_3'), value: RefundPolicy.FULL_OPTIONAL_SV },
  { label: t('product_form.placeholder.text_7'), value: RefundPolicy.CONDITIONAL_SV_ZERO_ALLOWED },
  { label: t('product_form.placeholder.text_13'), value: RefundPolicy.CONDITIONAL_SV_REQUIRED_POSITIVE },
  { label: t('product_form.placeholder.text_12'), value: RefundPolicy.NON_REFUNDABLE },
];

export const tabData: TabItems[] = [
  {
    activeId: 'form',
    icon: faUser,
    label: t('user.button.text_4')
  },
  {
    activeId: 'logs',
    icon: faHistory,
    label: t('user.button.text_5')
  }
];
